<template>
  <div class="boxall">
    <div class="page-head">
      <div class="title">统一市场</div>
      <span class="btn-container">
        <button class="detail-btn" @click="$emit('switchCenter')">
          {{ opened ? '返回' : '详情' }}
          <img src="../assets/images/more_arrow.png" alt="icon" />
        </button>
      </span>
    </div>
    <div class="boxnav">
      <div class="scroll-board">
        <dv-scroll-board :config="config" style="width: 100%; height: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnifiedMarket',

  props: {
    activeComp: {
      type: String,
      default: 'CenterMap'
    }
  },

  computed: {
    opened() {
      return this.activeComp === 'MarketDetail'
    }
  },

  data() {
    return {
      config: {
        header: ['集货中心', '送工厂数量(吨)', '送市场数量(吨)'],

        data: [
          ['黄梅城东集货中心', 128, 46],
          ['小池镇水产集货中心', 96, 3],
          ['濯港镇冷链集货点', 74, 29],
          ['蔡山镇水产交易中心', 83, 34],
          ['大河镇冷链中转站', 67, 21],
          ['独山镇水产集货点', 52, 18],
          ['孔垄镇水产供应站', 61, 23],
          ['五祖镇水产集散中心', 45, 16],
          ['新开镇水产中转点', 39, 14],
          ['龙感湖水产集货港', 112, 51]
        ]
      }
    }
  }
}
</script>

<style scoped>
.scroll-board {
  height: 100%;
  /* box-sizing: border-box; */
  /* padding: 8px; */
}

:deep(.dv-scroll-board .header) {
  font-size: 15px;
  background-color: rgb(0 133 183 / 52%) !important;
  height: 35px;
  border-radius: 16px;
}

:deep(.dv-scroll-board .header .header-item) {
  text-align: center !important;
  color: #baf5fd;
  line-height: 35px !important;
  height: 35px !important;
  /* width: 156px !important; */
}

:deep(.dv-scroll-board .rows .row-item) {
  /* border-radius: 16px; */
}

:deep(.dv-scroll-board .rows .ceil) {
  text-align: center !important;
  font-size: 12px;
  color: #49d8ec;
}

.page-head {
  position: relative;
}

.btn-container {
  position: absolute;
  top: 8px;
  right: 8px;
}

.detail-btn {
  background: #c7e9f600;
  padding: 2.4px 5px;
  color: #49d8ec;
  font-size: 12px;
  border-radius: 6.4px;
  border: 1.6px solid #49d8ec;
  box-shadow: 0 0 20px rgba(0, 191, 255, 0.4), inset 0 0 12px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);

  cursor: pointer;
}

.detail-btn img {
  height: 8px;
  width: 8px;
}
</style>
